import { createAction } from '@ngrx/store';

/**
 * Actions für den Analytics-Consent-Dialog.
 */
export class AnalyticsConsentDialogActions {
  private static readonly prefix = '[Dialog Analytics Consent]';

  /**
   * Öffnet den Dialog.
   */
  public static open = createAction(
    `${this.prefix} Open dialog`,
  );

  /**
   * Schließt den Dialog.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );
}
